import axios from 'axios';
import { Toast } from 'vant';
// 创建 axios 实例
const instance = axios.create({
    baseURL: 'https://yiqing.147.baiyunkj.cn', // 接口基地址
    timeout: 30000, // 请求超时时间
});

// 请求拦截器
instance.interceptors.request.use(
    (config) => {
        // 在发送请求之前做一些处理，例如添加 token
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截器
instance.interceptors.response.use(
    (response) => {
        // 对响应数据做一些处理
        if (response.data.code !== 1) {
            console.log('接口请求错误', response)
                // if (res.code === 401) {
                //     !messageUnAth &&
                //     (messageUnAth = ElMessage({
                //         message: "登录已过期，请重新登录",
                //         type: "error",
                //         duration: 1.5 * 1000,
                //         onClose: () => {
                //             store.dispatch("user/logout").then(() => {
                //                 location.reload();
                //             });
                //         },
                //     }));
                // } else {
                //     ElMessage({
                //         message: res.message || res.msg || "Error2",
                //         type: "error",
                //         duration: 3 * 1000,
                //     });
                // }
            Toast(response.data.message || response.data.msg || "Error")
                // return Promise.reject(new Error(response.message || response.msg || "Error"));
        } else {

            return response.data;
        }
    },
    (error) => {
        // 对响应错误做一些处理
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    console.error('未授权，请重新登录');
                    break;
                case 404:
                    console.error('请求的资源不存在');
                    break;
                case 500:
                    console.error('服务器内部错误');
                    break;
                default:
                    console.error('请求失败:', error.message);
            }
        }
        return Promise.reject(error);
    }
);

export default instance;